import { useCallback, useEffect, useState } from 'react';

/**
 * difference from useMediaQuery that we include server side mobile detections
 * in order to lazy load we have to use server detection
 * in order to resize detection we have to use matchMedia client detection
 * untill matchMedia event starts to work on the client we rely on server detection
 */
const useDeviceMedia = (mediaQuery: string, serverMedia: boolean): boolean => {
  const [matches, setMatches] = useState<boolean | undefined>(undefined);

  const updateTarget = useCallback((event: MediaQueryListEvent): void => {
    if (event.matches) {
      setMatches(true);
    } else {
      setMatches(false);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // need to set matches on init of the hook
      setMatches(window.matchMedia(mediaQuery).matches);
      const media: MediaQueryList = window.matchMedia(mediaQuery);
      // for better browser compatibility we should use addListener (safari < 14)
      media.addListener(updateTarget);

      return () => media.removeListener(updateTarget);
    }
  }, []);

  return typeof matches === 'undefined' ? serverMedia : matches;
};

export default useDeviceMedia;
